import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, model, effect, computed, input } from '@angular/core';
import { TabsModule } from 'primeng/tabs';
import { COMMENTS_TYPE, USER_ROLE } from '../../../@core/models/enums';
import { CONTRACT_USER_ROLE, SHARE_ACCESS } from '../../../@core/models/model';
import { AUDIT_MODULE } from '../../../contract-management/services/audit-log.service';
import { CommentsTabComponent } from './tabs/comments/comments-tab.component';
import { HistoryTabComponent } from './tabs/history/history-tab.component';
import { SourceTabComponent } from './tabs/sources/source-tab.component';

@Component({
  selector: 'app-innform-question-sidepanel',
  imports: [
    CommonModule,
    SourceTabComponent,
    CommentsTabComponent,
    HistoryTabComponent,
    TabsModule
  ],
  standalone: true,
  templateUrl: './innform-question-sidepanel.component.html',
  styleUrl: './innform-question-sidepanel.component.scss'
})
export class InnformQuestionSidepanelComponent {
  @Output() closePanelEvent = new EventEmitter<void>();
  @Input() sources: any[] = [];
  @Input() contract: string = '';
  @Input() question: string = '';

  userRole = input<string>('');
  activeTabIndex = model<string>('0');

  AUDIT_MODULE = AUDIT_MODULE;
  COMMENTS_TYPE = COMMENTS_TYPE;
  USER_ROLE = USER_ROLE;
  SHARE_ACCESS = SHARE_ACCESS;
  CONTRACT_USER_ROLE = CONTRACT_USER_ROLE;

  // Computed tabs based on permissions
  availableTabs = computed(() => {
    const role = this.userRole();
    const tabs: Array<{ value: string, label: string, type: 'source' | 'comments' | 'history' }> = [
      { value: '0', label: 'Source', type: 'source' }
    ];

    if (this.canComment(role)) {
      tabs.push({ value: tabs.length.toString(), label: 'Comments', type: 'comments' });
    }

    if (this.canViewHistory(role)) {
      tabs.push({ value: tabs.length.toString(), label: 'History', type: 'history' });
    }

    return tabs;
  });

  constructor() {
  }

  closePanel() {
    this.closePanelEvent.emit();
  }

  onTabChange(value: string | number | undefined) {
    if (value !== undefined) {
      this.activeTabIndex.set(value.toString());
    }
  }

  canComment(role?: string): boolean {
    const r = role || this.userRole();
    return r === CONTRACT_USER_ROLE.OWNER || r === CONTRACT_USER_ROLE.COMMENTER || r === CONTRACT_USER_ROLE.EDITOR || r === CONTRACT_USER_ROLE.ADMIN;
  }

  canViewHistory(role?: string): boolean {
    const r = role || this.userRole();
    return r === CONTRACT_USER_ROLE.ADMIN || r === CONTRACT_USER_ROLE.OWNER || r === CONTRACT_USER_ROLE.EDITOR;
  }

  getTabType(index: string): 'source' | 'comments' | 'history' | null {
    const tab = this.availableTabs().find(t => t.value === index);
    return tab ? tab.type : null;
  }

}
